<template>
    <div>
        <div class="nav-vertical">
          <ul class="nav nav-tabs nav-left" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" v-bind:href="'#t1'+rowData.integracao_id+''" role="tab" data-toggle="tab">
                <span class="nav-link-in">
                  Detalhes
                  <i class="fa fa-plus"></i>
                </span>
              </a>
            </li>
              <li class="nav-item" v-if="rowData.tp_envio.valor == 1">
                <a class="nav-link" v-bind:href="'#t2'+rowData.integracao_id+''" role="tab" data-toggle="tab">
                  <span class="nav-link-in">
                      API
                    <i class="fa fa-code-fork"></i>
                  </span>
                </a>
              </li>
              <li class="nav-item" v-if="rowData.tp_envio.valor == 2">
                <a class="nav-link" v-bind:href="'#t3'+rowData.integracao_id+''" role="tab" data-toggle="tab">
                  <span class="nav-link-in">
                    E-mail
                    <i class="fa fa-envelope"></i>
                  </span>
                </a>
              </li>
              <li class="nav-item" v-if="rowData.tp_envio.valor == 3">
                <a class="nav-link" v-bind:href="'#t5'+rowData.integracao_id+''" role="tab" data-toggle="tab">
                  <span class="nav-link-in">
                    FTP
                    <i class="fa fa-upload"></i>
                  </span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" v-bind:href="'#t7'+rowData.integracao_id+''" role="tab" data-toggle="tab">
                  <span class="nav-link-in">
                    Unidades
                    <i class="fa fa-building"></i>
                  </span>
                </a>
              </li>
              <li class="nav-item"  v-if="rowData.integracao_log.length>0">
                <a class="nav-link" v-bind:href="'#t8'+rowData.integracao_id+''" role="tab" data-toggle="tab">
                  <span class="nav-link-in">
                    Erros
                    <i class="fa fa-exclamation-triangle"></i>
                  </span>
                </a>
              </li>
          </ul>
			    <div class="tab-content">
            <div role="tabpanel" class="tab-pane fade in active show"  v-bind:id="'t1'+rowData.integracao_id+''">
              <table class="table" id="mais">
                  <thead>
                      <tr>
                          <th style="width: 25%">Layout de entrada</th>
                          <th style="width: 25%">Codigo do Layout</th>
                          <th style="width: 25%">Layout de saida</th>
                          <th style="width: 25%">Codigo do Layout</th>
                      </tr>
                  </thead>
                  <tbody>
                          <td>
                              <span v-if="rowData.layout_entrada != null">{{ rowData.layout_entrada.descr }}</span>
                          </td>
                          <td>
                              <span v-if="rowData.layout_entrada != null">{{ rowData.layout_entrada.cd }}</span>
                          </td>
                          <td>
                              <span v-if="rowData.layout_saida != null">{{ rowData.layout_saida.descr }}</span>
                          </td>
                          <td>
                              <span v-if="rowData.layout_saida != null">{{ rowData.layout_saida.cd }}</span>
                          </td>
                  </tbody>
              </table>
            </div><!--.tab-pane-->
            <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t2'+rowData.integracao_id+''">
              <table class="table" id="mais">
                  <thead>
                      <tr>
                          <th style="width: 20%">Usuario API</th>
                          <th style="width: 20%">Dominio API</th>
                          <th style="width: 20%">Endpoint Auth</th>
                          <th style="width: 20%">Endpoint da opreação</th>
                          <th style="width: 10%">Data que expira o token</th>
                          <!-- <th style="width: 10%">Transação ERP</th> -->
                      </tr>
                  </thead>
                  <tbody>
                      <tr class="bg-gray-light" style="display: table-row;">
                          <!--
                            O valor do usuário da API não é mais devolvido pela
                            API (TMS-8835): a tela só informa se a credencial
                            existe, nunca qual é. A data de expiração do token
                            não é segredo e continua sendo exibida abaixo.
                          -->
                          <td>
                              <span v-if="rowData.has_usuario_api" class="badge badge-secondary">•••• cadastrado</span>
                              <span v-else class="text-muted">Não cadastrado</span>
                          </td>
                          <td>
                              {{ rowData.dominio_api }}
                          </td>
                          <td>
                              {{ rowData.endpoint_auth }}
                          </td>
                          <td>
                              {{ rowData.endpoint_operacao }}
                          </td>
                          <td>
                              {{ this.DateFormat(rowData.dt_expira_token) }}
                          </td>
                      </tr>
                  </tbody>
                </table>
              </div><!--.tab-pane-->
              <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t3'+rowData.integracao_id+''">
                <table class="table" id="mais">
                    <thead>
                        <tr>
                          <th style="width: 20%">Email Registrado</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="bg-gray-light" style="display: table-row;">
                          <td>
                              {{ rowData.email }}
                          </td>
                        </tr>
                    </tbody>
                </table>
              </div><!--.tab-pane-->
              <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t5'+rowData.integracao_id+''">
                <table class="table" id="mais">
                    <thead>
                        <tr>
                          <th style="width: 20%">Codigo FTP</th>
                          <th style="width: 20%">Descrição</th>
                          <th style="width: 20%">Extensão</th>
                          <th style="width: 20%">Folder</th>
                          <th style="width: 20%">Host</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="bg-gray-light" v-if="rowData.config_ftp != null" style="display: table-row;">
                          <td>
                              {{ rowData.config_ftp.cd }}
                          </td>
                          <td>
                              {{ rowData.config_ftp.descr }}
                          </td>
                          <td>
                              {{ rowData.config_ftp.extensao }}
                          </td>
                          <td>
                              {{ rowData.config_ftp.folder }}
                          </td>
                          <td>
                              {{ rowData.config_ftp.host }}
                          </td>
                        </tr>
                    </tbody>
                </table>
              </div><!--.tab-pane-->
              <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t7'+rowData.integracao_id+''">
                <table class="table" id="mais">
                    <thead>
                        <tr>
                            <th style="width: 20%">Descrição</th>
                            <th style="width: 10%">Código</th>
                            <!-- <th style="width: 10%">Série</th> -->
                            <th style="width: 10%">Status</th>
                            <!-- <th style="width: 10%">Ação</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.integracao_unidade">
                            <td>
                                {{ item.unidade.descr }}
                            </td>
                            <td>
                                {{ item.unidade.cd }}
                            </td>
                            <td>
                                <span class="badge badge-success" v-if="item.status==1">Ativo</span>
                                <span class="badge badge-danger" v-if="item.status==2">Inativo</span>
                            </td>
                            <!-- <td>
                                <a v-if="item.status==2" @click="onActivateDesactivate(1, item, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                <a v-if="item.status==1" @click="onActivateDesactivate(2, item, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                            </td> -->
                        </tr>
                    </tbody>
                </table>
              </div><!--.tab-pane-->
              <div role="tabpanel" class="tab-pane fade" v-if="rowData.integracao_log.length>0" v-bind:id="'t8'+rowData.integracao_id+''">
                <table class="table" id="mais">
                    <thead>
                        <tr>
                            <th style="width: 10%">Entidade</th>
                            <th style="width: 40%">Descrição</th>
                            <th style="width: 10%">Data ocorrência</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.integracao_log">
                            <td>
                                <span v-if="item.doc_id != null" class="badge badge-secondary">Documento Num. {{item.doc.num_fiscal}}</span>
                                <span v-if="item.carga_id != null" class="badge badge-secondary">Carga Num. {{item.carga.num_carga}}</span>
                                <span v-if="item.manifesto_id != null" class="badge badge-secondary">Manifesto Num. {{item.manifesto.num_fiscal}}</span>
                                <span v-if="item.fatura_id != null" class="badge badge-secondary">Fatura Num. {{item.fatura.num_fiscal}}</span>
                                <span v-if="item.pesmot_id != null" class="badge badge-secondary">Motorista {{item.pessoa_motorista.pessoa_fisica.nome}}</span>
                                <span v-if="item.veiculo_id != null" class="badge badge-secondary">Veiculo {{item.veiculo.placa}}</span>
                            </td>
                            <td>
                                {{ item.descr }}
                            </td>
                            <td>
                                {{formatDateHora(item.dt_ultima_ocorrencia)}}
                            </td>
                        </tr>
                    </tbody>
                </table>
              </div><!--.tab-pane-->
			</div><!--.tab-content-->
		</div>
  </div>
  </template>

  <script>
    import moment from 'moment'

  export default {
      data () {
        return {
          helpForm: new Form({recordCollection: [], status:''}),
          cnpj_formatado: ''
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
      DateFormat: function(date) {
        if(date != null){
        return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
        }
        return "";
      },
      formatDateHora (value, fmt = 'DD/MM/YYYY HH:mm') {
        return (value == null)
          ? ''
          : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
      },
      onActivateDesactivate(helpForm){
        helpForm.patch('/api/integracao/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
              this.metodo();
            }
        })
        .catch(errors =>
        {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = '';
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof(errors[property]) === 'object') {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
      },
    },
  }
  </script>
